import React from 'react';
import { publicAsset } from '@/config/appPaths';
import { programContent, PROGRAM_WEBSITE } from '@/data/staticProgramData';
import { scrollToRegistration, scrollToSection } from '@/utils/scrollToSection';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '../Footer.scss';

const NAV_LINKS = [
  { id: null, label: 'Inicio', scrollTop: true },
  { id: 'programa', label: 'Programa' },
  { id: 'contenido', label: 'Contenido' },
  { id: 'modalidades', label: 'Inversión' },
  { id: 'faq', label: 'Preguntas frecuentes' },
];

const Footer = () => {
  const t = programContent;
  const currentYear = new Date().getFullYear();

  const goToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  const handleNavClick = (link) => {
    if (link.scrollTop) {
      goToTop();
      return;
    }
    scrollToSection(link.id);
  };

  return (
    <footer className="footer-basc">
      <div className="footer-basc__inner">
        <div className="footer-basc__grid">
          <div className="footer-basc__brand">
            <button
              type="button"
              className="footer-basc__logo-btn"
              onClick={goToTop}
              aria-label="BASC Perú - Inicio"
            >
              <img
                src={publicAsset('/basc/logo-basc-white.png')}
                alt="BASC Perú"
                className="footer-basc__logo"
              />
            </button>
            <p className="footer-basc__tagline">
              Formación de 120 horas en gestión, seguridad y protección portuaria, con modalidad
              híbrida, hasta 7 certificaciones y Misión académica internacional en Panamá. Inicio 10 de agosto de
              2026
            </p>
          </div>

          <nav className="footer-basc__col" aria-label="Navegación del sitio">
            <h3 className="footer-basc__heading">Navegación</h3>
            <ul className="footer-basc__links">
              {NAV_LINKS.map((link) => (
                <li key={link.label}>
                  <button
                    type="button"
                    className="footer-basc__link"
                    onClick={() => handleNavClick(link)}
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
            <button
              type="button"
              className="footer-basc__cta"
              onClick={scrollToRegistration}
            >
              Inscribirme
            </button>
          </nav>

          <div className="footer-basc__col footer-basc__col--contact">
            <h3 className="footer-basc__heading">{t.contact.title}</h3>
            <ul className="footer-basc__contact-list">
              {t.contact.items.map((item) => (
                <li key={item.value}>
                  <a
                    href={
                      item.type === 'email'
                        ? `mailto:${item.value}`
                        : `tel:+51${item.value.replace(/\s/g, '')}`
                    }
                    className="footer-basc__contact-item"
                  >
                    <span className="footer-basc__contact-icon" aria-hidden="true">
                      <i
                        className={
                          item.type === 'email' ? 'fa-solid fa-envelope' : 'fa-solid fa-phone'
                        }
                      />
                    </span>
                    <span className="footer-basc__contact-text">
                      <span className="footer-basc__contact-label">{item.label}</span>
                      <span className="footer-basc__contact-value">{item.value}</span>
                    </span>
                  </a>
                </li>
              ))}
              <li>
                <a
                  href={PROGRAM_WEBSITE}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-basc__contact-item"
                >
                  <span className="footer-basc__contact-icon" aria-hidden="true">
                    <i className="fa-solid fa-globe" />
                  </span>
                  <span className="footer-basc__contact-text">
                    <span className="footer-basc__contact-label">Sitio web</span>
                    <span className="footer-basc__contact-value">www.bascperu.org</span>
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-basc__bottom">
          <p className="footer-basc__copyright">
            Copyright © {currentYear} BASC Perú. Todos los derechos reservados.
          </p>
          <a
            href="https://analysofti.com"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-basc__credit"
            aria-label="Desarrollado por AnalySofTI"
          >
            <span className="footer-basc__credit-label">Desarrollado por:</span>
            <img
              src={publicAsset('/basc/analysofti-logo.png')}
              alt="AnalySofTI"
              className="footer-basc__credit-logo"
            />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
